import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ExperimentalRole} from 'samples/experimental-roles/ExperimentalRoleConstants';
import {getRoleLabelText, getRoleSymbol} from 'samples/experimental-roles/ExperimentalRoleUtil';
import PrimaryExperimentalRoleSymbol from 'samples/experimental-roles/PrimaryExperimentalRoleSymbol';

export interface RoleDisplayProps {
  role: ExperimentalRole;
}

/**
 * Displays a role with a type symbol and display text.
 * @param roleGroup
 * @constructor
 */
export default function RoleDisplay({role}: RoleDisplayProps): JSX.Element {
  return (
    <div className={css(styles.wellRole)}>
      <PrimaryExperimentalRoleSymbol
        radius={8}
        primaryRole={role.primaryRole}
        // Deliberately pulling out only the subrole here - it's too busy with the group number
        label={getRoleSymbol({subrole: role.subrole})}
      />
      {getRoleLabelText(role)}
    </div>
  );
}

const styles = StyleSheet.create({
  wellRole: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
});
